import React, { useState } from 'react';
import './Contact.css';

function Contact() {
  // Form verilerini tutacağımız React State yapısı
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    grade: '',
    message: ''
  });

  // Inputlara yazı yazıldıkça state'i güncelleyen fonksiyon
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Form gönderildiğinde çalışacak efsane WhatsApp yönlendirmesi
  const handleSubmit = (e) => {
    e.preventDefault();
    
    const phoneNumber = "905058865977"; // Turan Hoca'nın numarası
    
    // WhatsApp'a gidecek mesajın taslağı (Ters slash 'n' alt satıra geçer)
    const rawMessage = `Merhaba Turan Hoca, sitenizdeki form üzerinden size ulaşıyorum.\n\n👤 *Öğrenci/Veli Adı:* ${formData.name}\n📞 *Telefon:* ${formData.phone}\n🎯 *Sınıf/Hedef:* ${formData.grade}\n📝 *Ek Notlar:* ${formData.message ? formData.message : "Belirtilmedi"}`;
    
    // Mesajı URL formatına (boşlukları %20 vs. yapar) çeviriyoruz ki link bozulmasın
    const encodedMessage = encodeURIComponent(rawMessage);
    
    // WhatsApp API Linki
    const waLink = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    
    // Linki yeni sekmede aç
    window.open(waLink, '_blank');
  };

  return (
    <section className="contact-section" id="iletisim">
      <div className="contact-container">
        
        {/* Sol Taraf - Bilgiler ve Aksiyon */}
        <div className="contact-info">
          <span className="section-subtitle">İLETİŞİM</span>
          <h2>Hedeflerinize Ulaşmak İçin <span className="text-gold">İlk Adımı Atın.</span></h2>
          <p className="contact-desc">
            Kontenjanlar dolmadan ücretsiz ön görüşme, seviye tespiti ve ders programı planlaması için formu doldurun veya doğrudan bizimle iletişime geçin.
          </p>

          <div className="contact-methods">
            <a href="https://wa.me/905058865977" target="_blank" rel="noopener noreferrer" className="method-card">
              <div className="method-icon">📞</div>
              <div className="method-text">
                <h4>WhatsApp'tan Yazın</h4>
                <p>+90 505 886 59 77</p>
              </div>
            </a>

            <a href="https://www.instagram.com/turanhocamatematik/" target="_blank" rel="noopener noreferrer" className="method-card">
              <div className="method-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                </svg>
              </div>
              <div className="method-text">
                <h4>Instagram'da Takip Edin</h4>
                <p>@turanhocamatematik</p>
              </div>
            </a>
          </div>
        </div>

        {/* Sağ Taraf - Dinamik WhatsApp Formu */}
        <div className="contact-form-wrapper">
          <form className="contact-form" onSubmit={handleSubmit}>
            <h3>Sizi Arayalım</h3>
            
            <div className="input-group">
              <label>Adınız Soyadınız</label>
              <input 
                type="text" 
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Örn: Ahmet Yılmaz" 
                required 
              />
            </div>

            <div className="input-group">
              <label>Telefon Numaranız</label>
              <input 
                type="tel" 
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Örn: 0555 555 55 55" 
                required 
              />
            </div>

            <div className="input-group">
              <label>Öğrenci Sınıfı / Hedef</label>
              <select 
                name="grade"
                value={formData.grade}
                onChange={handleChange}
                required
              >
                <option value="" disabled>Seçiniz...</option>
                <option value="LGS Hazırlık (8. Sınıf)">LGS Hazırlık (8. Sınıf)</option>
                <option value="YKS Hazırlık (12. Sınıf / Mezun)">YKS Hazırlık (12. Sınıf / Mezun)</option>
                <option value="Ara Sınıf Takviye">Ara Sınıf Takviye</option>
                <option value="Diğer">Diğer</option>
              </select>
            </div>

            <div className="input-group">
              <label>Eklemek İstedikleriniz (Opsiyonel)</label>
              <textarea 
                rows="4" 
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Öğrencinin durumu veya sormak istedikleriniz..."
              ></textarea>
            </div>

            <button type="submit" className="submit-btn">WhatsApp Üzerinden Gönder</button>
          </form>
        </div>

      </div>
    </section>
  );
}

export default Contact;